<template>
  <router-view />
</template>

<script>
export default {
  name: "NewsPage",
  breadcrumb: {
    title: "Новости",
    to: "/news"
  }
};
</script>
